import { DocumentEvent } from '../../../constants';

export enum DocumentPrivateWebsocketEvent {
  DocumentStatusChange = DocumentEvent.DocumentStatusChange,
  DocumentError = DocumentEvent.DocumentError,
  TransitionPerformed = DocumentEvent.TransitionPerformed,
  DocumentWorkflowSwitch = DocumentEvent.DocumentWorkflowSwitch,

  // Laravel Echo auto-prepends 'App\Events\' to event names (e.g. 'DocumentStatusChange'
  // becomes 'App\Events\DocumentStatusChange'). For events outside that namespace, prefix
  // with '.' to use the fully qualified class name instead.
  EnvelopeUpdated = '.Incept\\Signature\\Events\\EnvelopeUpdated',
  DocumentNotification = DocumentEvent.DocumentNotification,
  Calculated = DocumentEvent.Calculated,
  CalculateFailed = DocumentEvent.CalculateFailed,
  AttachmentUploadStateChanged = DocumentEvent.AttachmentUploadStateChanged,
  FraudAnalysisUpdated = DocumentEvent.FraudAnalysisUpdated,
}
